import React, { useEffect } from 'react';
import { Spinner } from '@insurancemenu/imenu-components-lib';
import { observer } from 'mobx-react-lite';
import { useRootStore } from 'store/rootStore';
import { Redirect, generatePath } from 'react-router-dom';
import AppRouter from 'routes/AppRouter';
import { employerRights } from '@insurancemenu/imenu-components-lib/dist/utils/accessRights';
import { SupportedUserRoles } from '@insurancemenu/imenu-components-lib/dist/types';
import Cookies from 'js-cookie';
import { RouteV2Id, ROUTES_CONFIG_V2 } from 'routes/routesConfigV2';
import { SpinnerWrapperStyled, AppWrapperStyled } from './globalStyles';

/**
 * Prefer groupId from cookies when present. An empty cookie must not be passed to
 * generatePath — both profile routes treat groupId as optional and the page
 * will pick the first affiliation via SubscriberMultiLoginModule.
 */
function getEmployeeAppRedirectPath(userRoles: SupportedUserRoles[], groupIdFromCookie?: string): string {
  const routeId = employerRights(userRoles) ? RouteV2Id.EMPLOYER_PROFILE : RouteV2Id.EMPLOYEE_PROFILE;
  return generatePath(ROUTES_CONFIG_V2[routeId].path, groupIdFromCookie ? { groupId: groupIdFromCookie } : {});
}

const EmployeeRedirect: React.FC<{ userRoles: SupportedUserRoles[] }> = ({ userRoles }) => {
  return <Redirect to={getEmployeeAppRedirectPath(userRoles, Cookies.get('groupId'))} />;
};

/**
 * Employee / employer self-enroll experience: loads domain by sponsorId, then subscriber routes.
 */
const EmployeeApp: React.FC = observer(() => {
  const {
    domainStoreV2: { loading: domainLoading, getDomainById },
    userStore: { sponsorId },
  } = useRootStore();

  useEffect(() => {
    if (sponsorId) {
      // Pass domain id explicitly, instead of grabbing from Cookies, because if an EE belongs to 2 groups in 2 different sponsors, cookies for such ee won't change
      void getDomainById(sponsorId);
    }
  }, [sponsorId]);

  if (domainLoading) {
    return (
      <SpinnerWrapperStyled>
        <Spinner />
      </SpinnerWrapperStyled>
    );
  }

  return (
    <AppWrapperStyled>
      <AppRouter RedirectComponent={EmployeeRedirect} />
    </AppWrapperStyled>
  );
});

export default EmployeeApp;
